<template>
  <div class="ticket-dashboard-filters">
    <div class="ticket-dashboard-filter-items-wrapper">
      <div class="ticket-dashboard-filter-item">
        <p class="drop-down-label">Select Location</p>
        <el-select v-model="selected_location" filterable size="small" placeholder="Select Location" @change="getTicketsDashboardReports">
          <el-option v-for="(item, index) in outlet_list" :key="'outlet-'+index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- <multilevel-locations-dropdown></multilevel-locations-dropdown> -->
      </div>
      <div class="ticket-dashboard-filter-item">
        <p class="drop-down-label">Report</p>
        <el-select v-model="report_view" filterable size="small" placeholder="Select Report" @change="(event) => {showDateByQueryReport(event); getTicketsDashboardReports();}">
          <el-option value="wtd" label="Week To Date"></el-option>
          <el-option value="mtd" label="Month To Date"></el-option>
          <el-option value="ytd" label="Year To Date"></el-option>
          <el-option value="custom" label="Custom"></el-option>
        </el-select>
      </div>
      <div class="ticket-dashboard-filter-item">
        <p class="drop-down-label">From</p>
        <el-date-picker
          v-model="from_date"
          type="date"
          size="small"
          placeholder="Pick a day"
          :disabled="report_view != 'custom'"
          :picker-options="{
            disabledDate: disabledDueDate,
            firstDayOfWeek: 1,
          }"
          @change="getTicketsDashboardReports"
        ></el-date-picker>
      </div>
      <div class="ticket-dashboard-filter-item">
        <p class="drop-down-label">To</p>
        <el-date-picker
          v-model="to_date"
          type="date"
          size="small"
          placeholder="Pick a day"
          :disabled="report_view != 'custom'"
          :picker-options="{
            disabledDate: disabledTaskReportToDate,
            firstDayOfWeek: 1,
          }"
          @change="getTicketsDashboardReports"
        ></el-date-picker>
      </div>
      <div class="ticket-dashboard-filter-item">
        <p class="drop-down-label">Report Type</p>
        <el-select v-model="report_type" filterable size="small" placeholder="Select Report Type" @change="getTicketsDashboardReports">
          <el-option value="location" label="By Location"></el-option>
          <el-option value="agent" label="Agent Wise SLA"></el-option>
          <el-option value="priority" label="Priority Wise"></el-option>
          <el-option value="resolution" label="Average Resolution Time"></el-option>
          <el-option value="category" label="By Category"></el-option>
        </el-select>
      </div>
      <div class="ticket-dashboard-filter-item">
        <p class="drop-down-label">Category</p>
        <el-select v-model="report_type_value" filterable multiple collapse-tags size="small" placeholder="Select Category" @change="getTicketsDashboardReports">
          <el-option v-for="(item, index) in category_list" :key="'category-'+index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import ticketDashboardMixins from '../../../../../mixins/ticketDashboardMixins';
import ticketsService from '../../../../services/ticketsService';
// import MultilevelLocationsDropdown from '../../../shared/MultilevelLocationsDropdown.vue';
export default {
  name: 'TicketDashboardFilters',
  components: {
    // MultilevelLocationsDropdown
  },
  mixins: [ticketDashboardMixins],
  mounted() {
    this.getAllOutlets();
  },
  methods: {
    getAllOutlets() {
      ticketsService.getAllOutletStores()
      .then(res => {
        let result = JSON.parse(res.data);
        this.outlet_list = [{name: 'All', id: null},...result];
      })
      .catch(err => {
        console.error(err);
      })
    }
  }
}
</script>